// The Add Friend home-screen app (thread 1a18d2698d19d52b, Levi 2026-10-30:
// "a Save to Home Screen button ... a K plus a friend icon").
//
// One portal page can be saved as its own app. /add-friend carries its own
// manifest, icon and title (see public/index.html, which swaps them in on that
// path only), and opens the Add Friend form on the portal's Home. The rep is
// still the signed-in portal user, so the Friend is credited to them as always.
// No login goes in the link.
//
// Pure helpers plus two browser reads. No network, no state. The literals in
// public/index.html must match ADD_FRIEND_APP_PATH and ADD_FRIEND_MANIFEST;
// test/addFriendHomeScreen.test.js fails if they drift.

export const ADD_FRIEND_APP_PATH = "/add-friend";
export const ADD_FRIEND_MANIFEST = "/manifest-add-friend.json";
export const ADD_FRIEND_OPEN = "add-friend";

// Where /add-friend lands: the portal's Home with the Add Friend form open.
// `save=1` carries through so the form opens its Save to Home Screen steps.
export function addFriendHomePath(search = "") {
  const save = new URLSearchParams(search).get("save") === "1";
  return `/home?open=${ADD_FRIEND_OPEN}${save ? "&save=1" : ""}`;
}

// True only on a document that loaded the Add Friend manifest. Install and
// Add to Home Screen read the manifest and icon of the page they are run on,
// so the Save button needs this to know which app it would save.
export function isAddFriendDocument() {
  const link = document.querySelector('link[rel="manifest"]');
  return link?.getAttribute("href") === ADD_FRIEND_MANIFEST;
}

export function isStandaloneApp() {
  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true
  );
}

export function isIosBrowser() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent || "");
}

export function isPhoneBrowser() {
  return /android|iphone|ipad|ipod/i.test(window.navigator.userAgent || "");
}

// Inside the installed portal app a page cannot be saved as a second icon, so
// the Add to Home Screen button hands the Add Friend page to the phone's own
// browser, with its save steps open (thread 1a197767f875849d, Levi 2026-11-01:
// "it doesn't give them an option to open it as a link on the browser").
// iPhone: the x-safari-https scheme opens Safari (iOS 17 and later). Android: an
// intent URL opens Chrome, and falls back to the page itself if Chrome is missing.
export function phoneBrowserSaveUrl(origin = window.location.origin) {
  const url = new URL(`${ADD_FRIEND_APP_PATH}?save=1`, origin);
  if (isIosBrowser()) return `x-safari-${url.href}`;
  const fallback = encodeURIComponent(url.href);
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${url.protocol.replace(":", "")};package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
}

// Chrome on Android offers beforeinstallprompt once the page is installable.
// Captured at startup so it is still there when the Save button is tapped.
let deferredInstallPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
  });
}

export function getInstallPrompt() {
  return deferredInstallPrompt;
}
